import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var RedoIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("path", {
                            d: "M21.967 2.957c-.6 0-1 .4-1 1v3.7l-2.9-2.8c-.8-.8-2.1-1.8-3.7-2.3-5.4-1.8-11.1.9-12.8 6.1-.9 2.5-.7 5.3.4 7.7 1.2 2.4 3.2 4.2 5.7 5.1 1.1.3 2.2.5 3.3.5 4.1 0 7.9-2.5 9.4-6.7.2-.5-.1-1.1-.6-1.3-.5-.2-1.1.1-1.3.6-1.5 4.2-6 6.3-10.2 4.9-2-.7-3.6-2.1-4.5-4.1-.9-1.9-1-4.1-.3-6.2 1.4-4.1 6-6.3 10.3-4.9 1 .3 1.9.9 3 1.9l2.7 2.8h-3.5c-.6 0-1 .4-1 1s.4 1 1 1h6c.1 0 .2 0 .3-.1h.2c.1 0 .2-.1.3-.2 0 0 0-.1.1-.1 0-.1.1-.1.1-.2v-.2V3.957c0-.6-.4-1-1-1z"
                        }),
                        _jsxs("g", {
                            fillRule: "evenodd",
                            children: [
                                _jsx("use", {}),
                                _jsx("use", {
                                    fillRule: "nonzero"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
RedoIcon.isCarinaIcon = true;
export default RedoIcon;
